import { render } from "./signature-double-authentification.vue?vue&type=template&id=a2bc4290"
import script from "./signature-double-authentification.vue?vue&type=script&lang=js"
export * from "./signature-double-authentification.vue?vue&type=script&lang=js"

import "./signature-double-authentification.vue?vue&type=style&index=0&id=a2bc4290&lang=css"

import exportComponent from "C:\\Users\\cbetta\\Desktop\\workspace\\Developpement\\hub-web-apps\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__